export const ERROR_CODES = Object.freeze({
  INVALID_REFERAL_CODE: 'No referal code',
  INVALID_PHONE_NUMBER: 'Invalid phone number',
  CUSTOMER_ALREADY_EXISTS: 'Customer already exists',
  REFERAL_CODE_NOT_FOUND: 'No Customer with that code',
})
